/**
 * Admin Dashboard App
 * Main application component with routing
 */

import { ElectrumProvider } from "@redenvelopeorg/ofx-electrum"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { ErrorBoundary } from "./components/ErrorBoundary"
import { Layout } from "./components/Layout"
import { ProtectedRoute } from "./components/ProtectedRoute"
import { AuthProvider } from "./context/AuthContext"
import { ActivityLogPage } from "./pages/ActivityLog"
import { AdminUsersPage } from "./pages/AdminUsers"
import { CreateOrganizationPage } from "./pages/CreateOrganization"
import { DashboardPage } from "./pages/Dashboard"
import { LoginPage } from "./pages/Login"
import { OrganizationDetailPage } from "./pages/OrganizationDetail"
import { OrganizationsPage } from "./pages/Organizations"
import { CurrencyControlsPage } from "./pages/CurrencyControls"

export default function App() {
  return (
    <ErrorBoundary>
      <ElectrumProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <DashboardPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/organizations"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <OrganizationsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/organizations/new"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <CreateOrganizationPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/currency-controls"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <CurrencyControlsPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/organizations/:orgId"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <OrganizationDetailPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/activity-log"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <ActivityLogPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin-users"
                element={
                  <ProtectedRoute>
                    <Layout>
                      <AdminUsersPage />
                    </Layout>
                  </ProtectedRoute>
                }
              />

              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ElectrumProvider>
    </ErrorBoundary>
  )
}
